module.exports = __webpack_public_path__ + "images/433b379db52515c4d3060360e8041f60.png";